import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {ReportService} from '../../../shared/services/report.service';
import {OwnerElement, OwnerLoaderService, TableDataSourceElement} from './service/owner-loader.service';


@Component({
    selector: 'pm-owner-list',
    templateUrl: './owner-list.component.html',
    styleUrls: ['./owner-list.component.css'],
    standalone: false
})
export class OwnerListComponent implements OnInit, OnDestroy {
  folded = false;
  searchResultsSubscription: Subscription;
  loading = true;
  displayedColumns = ['owner', 'path', 'label'];
  tableDataSource = new MatTableDataSource<TableDataSourceElement>();
  activeSearchElement: any = null;
    private reportService= inject(ReportService);
  private ownerLoaderService = inject(OwnerLoaderService);

  ngOnInit() {
    this.searchResultsSubscription =
      this.ownerLoaderService.loadOwners().pipe(
        finalize(() => this.loading = false)
      ).subscribe(dataSource => this.tableDataSource.data = dataSource);
  }

  ngOnDestroy() {
    this.searchResultsSubscription.unsubscribe();
  }

  navigateToNode(searchElement: OwnerElement) {
    this.activeSearchElement = searchElement.id;
    this.reportService.navigate(searchElement);
  }

  getRowSpan(element: TableDataSourceElement) {
      return element.ownerRowSpan ?? 1;
  }
}
